const commonStyles = {
    container: (provided) => ({
      ...provided,
      width: '300px',
      fontSize: '16px',
    }),
    control: (provided) => ({
      ...provided,
      borderRadius: '6px',
      height: '44px',
      borderColor: '#686869',
      borderWidth: '0.5px',
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? 'white' : 'black',
      backgroundColor: state.isSelected ? '#B2C7CE' : state.isFocused ? '#f0f0f0' : provided.backgroundColor,
    }),
  };
  
  export const customStyles = {
  
    addressInput: {
      ...commonStyles,
      container: (provided) => ({
        ...commonStyles.container(provided),
        width: '100%',
      }),
    },

    popup: {
      ...commonStyles,
      option: (provided, state) => ({
        ...provided,
        color: 'black',
        backgroundColor: state.isSelected
          ? '#B2C7CE'
          : provided.backgroundColor,
      }),    
      control: (provided, {isDisabled }) => ({
        ...provided,
        borderRadius: '6px',
        height: '44px',
        borderColor: '#686869',
        borderWidth: '0.5px',
        backgroundColor: isDisabled ? "light-dark(rgba(239, 239, 239, 0.3), rgba(59, 59, 59, 0.3))" : "white",
      }),
      container: (provided) => ({
        ...provided,
        width: '100%',
        fontSize: '16px',
        paddingTop: '0px',
        color: "#000",
        borderRadius: '6px',
      }),
      singleValue: (provided) => ({
        ...provided,
        marginTop: '12px', 
        paddingLeft: '1px',
        color: "#000"
      }),
      placeholder: (provided) => ({
        ...provided,
        paddingTop: '5px', 
        // marginRight: '5px', 
        paddingLeft: '1px',
        fontWeight: '400',
        color: "#4F4F4F",
        fontFamily: "Roboto",
        fontSize: "16px",
        fontWeight: "500",
        lineHeight: "24px",
        letterSpacing: "0.024px",
      }),
      menu: (provided) => ({
        ...provided,
        zIndex: 9999,
      }),
    },

    searchInput: {
      ...commonStyles,
      container: (provided) => ({
        ...commonStyles.container(provided),
        width: '140px',
      }),
      control: (provided, state) => ({
        ...commonStyles.control(provided,state),
        height: '36px',
        borderRadius: '25px',
        minHeight: '20px',
      }),
    },
  };
  